import React from "react";
import { Icon, Button } from "semantic-ui-react";
import { StepJedha, ConfirmationJedha } from "../style/style";

const Confirmation = () => {
  return (
    <div className="col-sm-10 col-md-8 m-auto">
      <div className="d-none ml-auto mr-auto mt-4 d-md-flex justify-content-center">
        <StepJedha.Group unstackable fluid>
          <StepJedha completed>
            <Icon name="user" />
            <StepJedha.Content>
              <StepJedha.Title>Informations d'inscription</StepJedha.Title>
            </StepJedha.Content>
          </StepJedha>
          <StepJedha completed>
            <Icon name="payment" />
            <StepJedha.Content>
              <StepJedha.Title>Informations Bancaire</StepJedha.Title>
            </StepJedha.Content>
          </StepJedha>
          <StepJedha active>
            <Icon name="info" />
            <StepJedha.Content>
              <StepJedha.Title>Confirmation</StepJedha.Title>
            </StepJedha.Content>
          </StepJedha>
        </StepJedha.Group>
      </div>
      <ConfirmationJedha className="col-12 p-3 ml-auto mr-auto mt-5 d-flex flex-column justify-content-center">
        <h1 className="text-center">
          <span role="img" aria-label="rocket">
            🚀
          </span>{" "}
          Bienvenue chez nous!{" "}
          <span img="role" aria-label="rocket">
            🚀
          </span>
        </h1>
        <p className="text-center">
          Merci d'avoir pris le temps de remplir le formulaire. Nous avons bien
          reçu vos informations.
        </p>

        <h2 className="text-center">
          <span role="img" aria-label="wave">
            👋
          </span>{" "}
          Pour la suite
        </h2>
        <p className="text-center">
          Vous allez recevoir par email votre contrat de formation à signer
          électroniquement. En attendant, n'hésitez pas à faire un tour sur nos
          réseaux sociaux{" "}
        </p>

        <div className="d-flex justify-content-center">
          <Button
            color="facebook"
            className="m-2"
            href="https://www.facebook.com/jedhaBootcamp/"
          >
            <Icon name="facebook" /> Facebook
          </Button>
          <Button
            color="youtube"
            className="m-2"
            href="https://www.youtube.com/channel/UC_eP8EL0XZYwmTf1_m1U6-Q"
          >
            <Icon name="youtube" /> YouTube
          </Button>
          <Button
            color="linkedin"
            className="m-2"
            href="https://www.linkedin.com/school/jedhabootcamp/"
          >
            <Icon name="linkedin" /> LinkedIn
          </Button>
          <Button
            color="instagram"
            className="m-2"
            href="https://www.instagram.com/jedhabootcamp/"
          >
            <Icon name="instagram" /> Instagram
          </Button>
          <Button
            color="twitter"
            className="m-2"
            href="https://twitter.com/JedhaBootcamp"
          >
            <Icon name="twitter" /> Twitter
          </Button>
        </div>
      </ConfirmationJedha>
    </div>
  );
};

export default Confirmation;
